/**
 * External Dependencies
 * Comment out scripts that are not used to save on page load
 */
import { Alert, Button, Collapse, Dropdown, Modal, Tab } from 'bootstrap';
import { CountUp } from 'countup.js';
import Player from '@vimeo/player';
import sheets_data from './sheets_data';
// import 'bootstrap-select';
// import AOS from 'aos';
import 'waypoints/lib/jquery.waypoints.min.js';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/lazysizes';
import 'bootstrap/js/dist/tab'
// import anime from 'animejs/lib/anime.min.js';

/**
 * Internal Scripts
 * Comment out scripts that are not used to save on page load
 */
// import './people.js';
import './slider.js';

// Hide show back to top links.
const backToTop = (el) => {
  if (window.pageYOffset > 300) {
    $(el).fadeIn();
  } else {
    $(el).fadeOut();
  }

  document.querySelectorAll(el).forEach(function(element, index) {
    element.addEventListener('click', function() {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, { once: true });
  });
};

const countStart = () => {
  const counters = document.querySelectorAll('.js-count-up');

  counters.forEach((item) => {
    const value = item.dataset.value;
    const decOptions = {
      decimalPlaces: 1,
    };

    if(value.indexOf('.') >= 0) {
      const counter = new CountUp(item, value, decOptions);
      counter.start();
    } else {
      const counter = new CountUp(item, value);
      counter.start();
    }
  });
};

$(() => {

  // AOS.init();
  sheets_data.init();

  // Get CSS variables
  const $window = $(window);
  const $body = $('body');
  const navCollapsible = document.getElementById('navbar');
  let root = getComputedStyle(document.documentElement);
  let colorPrimary = root.getPropertyValue('--primary');
  let colorSecondary = root.getPropertyValue('--secondary');
  let xsBreakpoint = root.getPropertyValue('--breakpoint-xs').replace('px','');
  let smBreakpoint = root.getPropertyValue('--breakpoint-sm').replace('px','');
  let mdBreakpoint = root.getPropertyValue('--breakpoint-md').replace('px','');
  let lgBreakpoint = root.getPropertyValue('--breakpoint-lg').replace('px','');
  let xlBreakpoint = root.getPropertyValue('--breakpoint-xl').replace('px','');

  // Scroll to open accordion
  // see example https://stackoverflow.com/questions/35992900/bootstrap-accordion-scroll-to-top-of-active-open-accordion-on-click#answer-35992958
  $('.accordion-collapse').on('shown.bs.collapse', function (e) {
    const header = $('.header').height();
    var $panel = $(this).closest('.accordion-item');
    $('html,body').animate({
      scrollTop: $panel.offset().top - header,
    }, 500);
  });

  // Enable bootstrap select for all selects
  // $('select').selectpicker();

  // Count up on scroll to
  if($('.stats').length ) {
    new Waypoint({
      element: document.querySelector('.stats'),
      handler: function () {
          countStart()
          this.destroy()
      },
      offset: '90%',
    });
  }

  if ($('.hero').not('.hero__simple').length) {
    $('body').addClass('-has-hero');
  }

  // Change frontpage url path that has contain with hash '#'
  if(!$('.page-home-page').length){
    let front_menu = $('#menu-main-menu .nav-item, #menu-top-navigation .nav-item');

    front_menu.each(function() {
      let nav_link = $(this).find('a.nav-link');
      let navlink_val = nav_link.attr('href');

      if (nav_link.is('[href^="#"]')) {
        nav_link.attr('href', '/'+navlink_val);
      }
    });
}


  // Video player
  if ($('div[data-id="vimeo-video"]').length && $('iframe[data-id="vimeo-video"]').length) {
    $('.video').each(function() {
      let vimeoPlayer = new Player($(this).find('iframe'));
      const $vimeoPlayButton = $(this).find('div[data-id="vimeo-video"]');
      $(this).on('click', function () {
        vimeoPlayer.play();
        $vimeoPlayButton.hide();
      });

      vimeoPlayer.on('pause', function () {
        $vimeoPlayButton.show();
      });
    });
  }

  // Smooth scroll to
  $('#menu-main-menu .nav-link').click(function () {
    if (!$(this).hasClass("dropdown-toggle")) {
      const $link = $('.nav-link');
      const sectionTo = $(this).attr('href').replace(new RegExp('/', ''),"");
      const header = $('.header').height();
      const navbar = $('#navbar');
      const $this = $(this);

      $link.removeClass('active');
      $this.addClass('active');

      $(navbar).collapse('hide');

      $('html,body').animate({
        scrollTop: $(sectionTo).offset().top - header,
      }, 500);
    }
  });

  if (navCollapsible) {
    navCollapsible.addEventListener('shown.bs.collapse', event => {
      $body.addClass('nav-open');
    });

    navCollapsible.addEventListener('show.bs.collapse', event => {
      $('header').addClass('-nav-show');
    });

    navCollapsible.addEventListener('hidden.bs.collapse', event => {
      if($body.hasClass('nav-open')) {
        $body.removeClass('nav-open');
        $('header').removeClass('-nav-show');
      }
    });
  }

  window.addEventListener('scroll', function() {
    backToTop('#back2top');
  });

  // Add scroll class on scroll/load
  $window.on("scroll load", function() {
      if($window.scrollTop() > 150) {
          $body.addClass("scroll-down");
      } else {
          //remove the background property so it comes transparent again (defined in your css)
          $body.removeClass("scroll-down");
      }
  });

  if (window.location.hash) {
    let $getHash = window.location.hash;
    if($($getHash).length) {
      let $personSelector = $(`[data-bs-target="${$getHash}"]`);
      if($personSelector.length) {
        $personSelector.trigger('click');
      }
    }
  }

  $('.people__modal').on('show.bs.modal', function (e) {
    $('html').css('overflow-x', 'unset');
    $('#app').css('overflow-x', 'hidden');
  });

  $('.people__modal').on('hidden.bs.modal', function (e) {
    $('html').css('overflow-x', '');
    $('#app').css('overflow-x', '');
  });
});

window.addEventListener('load', function () {
  backToTop('#back2top');

  if (window.location.hash) {
    let $getHash = window.location.hash;
    if($($getHash).length) {
      if($('#wpadminbar').length) {
        $('html,body').animate({
          scrollTop: ($($getHash).offset().top - ($('header.header').outerHeight() + $('#wpadminbar').outerHeight()))
        }, 100);
      }else {
        $('html,body').animate({
          scrollTop: ($($getHash).offset().top - $('header.header').outerHeight())
        }, 100);
      }
    }
  }
}, false);

document.querySelectorAll('.person__toggle').forEach(link => {
  link.addEventListener('click', function() {
    event.preventDefault(); // Prevent the default link behavior
    scrollToPerson(this.getAttribute('href'));
  });
});

// Function to scroll to a person element
function scrollToPerson(targetId) {
  const targetElement = document.getElementById(targetId.substring(1)); // Remove the leading #

  if (targetElement) {
    targetElement.scrollIntoView({ behavior: 'smooth' });
  }
}

// Add scroll class on scroll/load
window.addEventListener('scroll', function() {
  backToTop('#back2top');
});

// Add scroll class on scroll/load
window.addEventListener('scroll load', function() {
  if (window.scrollY > 150) {
    document.body.classList.add('scroll-down');
  } else {
    // Remove the 'scroll-down' class
    document.body.classList.remove('scroll-down');
  }
});

// Wrap every letter in a span
// var textWrapper = document.querySelector('.animate-text');
// textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");
//
// window.addEventListener('load', function () {
//     anime.timeline({loop: false})
//         .add({
//             targets: '.animate-text .letter',
//             scale: [4, 1],
//             opacity: [0, 1],
//             translateZ: 0,
//             duration: 1200,
//             delay: (el, i) => 70 * i
//         });
// }, false);
